<template>
  <FormBoxCheckboxGroup
    v-model="assetTypes"
    :options="options"
    :data-e2e="TaxCypressAttribute.inputs.SELECT_ASSET_TYPE"
  >
    <template #body="{ option }">
      <div class="is-flex is-align-items-flex-start m-b-20">
        <img :src="option.image" alt="option.icon" />
        <div class="m-l-10">
          <p class="is-size-4 has-text-weight-semibold">
            {{ option.value }}
          </p>
          <p class="is-size-5" v-dompurify-html="option.description" />
        </div>
      </div>
    </template>
    <template #main="{ option }">
      <div v-if="isSelected(option)">
        <component
          :is="option.component"
          :value="computedValue[option.dataKey]"
          @input="setInputData"
          @on-add="addNewEntity"
          @on-delete="deleteEntity"
          @on-destroy="clearAssets"
        />
      </div>
    </template>
  </FormBoxCheckboxGroup>
</template>

<script>
import { TaxCypressAttribute } from '@/modules/tax/constants/TaxCypressAttribute';
import FormBoxCheckboxGroup from '@/modules/core/form/components/FormBoxCheckboxGroup.vue';
import { FormComputedValueMixin } from '@/modules/core/form/mixins/FormComputedValueMixin';
import { FinalTaxesAssetType } from '@/modules/tax/enums/FinalTaxesAssetType';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'FinalTaxesAssetForm',
  mixins: [FormComputedValueMixin],
  components: { FormBoxCheckboxGroup },
  static: {
    TaxCypressAttribute
  },
  local() {
    return {
      options: FinalTaxesAssetType.getValues()
    };
  },
  data() {
    return {
      assetTypes: []
    };
  },
  methods: {
    setInputData(type, field, value, rowData) {
      const index = this.computedValue[type].findIndex((row) => row.tempId === rowData.tempId);
      this.computedValue[type][index][field] = value;
    },
    addNewEntity(type, rowData) {
      this.computedValue[type] = [...this.computedValue[type], rowData];
    },
    deleteEntity(type, rowData) {
      this.computedValue[type] = this.computedValue[type].filter(
        (row) => row.tempId !== rowData.tempId
      );
    },
    clearAssets(type) {
      this.computedValue[type] = [];
    },
    isSelected(option) {
      return this.assetTypes.includes(option.key);
    },
    onInit() {
      this.options.map((option) => option.getComponent());
    }
  },
  mounted() {
    this.onInit();
  }
};
</script>

<style scoped>
.is-size-1 {
  font-size: var(--ce-48px) !important;
}
</style>
